<!--
 * @Author: Nemo
 * @Description: 错误面板组件
 * @Date: 2024-07-10
 * @LastEditors: Nemo
-->
<template>
  <div class="error-panel" v-if="visible">
    <div class="error-header">
      <div class="left-section">
        <img src="@/assets/images/err.png" alt="error" class="error-icon" />
        <span class="error-title">{{ $t('message.result.failed') }}</span>
      </div>
      <div class="error-close" @click="handleClose">
        <span class="el-icon-close"></span>
      </div>
    </div>

    <div class="error-body">
      <div class="error-content">
        <div class="error-text">
          <slot>{{ errorText }}</slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnErrorMsgPanel',
  props: {
    // 错误文本信息
    errorText: {
      type: String,
      default: '',
    },
    // 是否默认显示
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isVisible: this.visible,
    };
  },
  methods: {
    handleClose() {
      this.isVisible = false;
      this.$emit('onClose');
    },
    // 提供方法用于外部控制显示/隐藏
    show() {
      this.isVisible = true;
    },
    hide() {
      this.isVisible = false;
    },
  },
  watch: {
    visible(val) {
      this.isVisible = val;
    },
    isVisible(val) {
      this.$emit('update:visible', val);
    },
  },
};
</script>

<style lang="scss" scoped>
.error-panel {
  width: 100%;
  padding: 16px;
  background-color: #FFECE8;
  box-sizing: border-box;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  height: auto;

  .error-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;

    .left-section {
      display: flex;
      align-items: center;
    }
  }

  .error-icon {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }

  .error-title {
    font-family: "Open Sans bold";
    font-weight: 600;
    font-size: 16px;
    color: #1D2129;
  }

  .error-body {
    display: flex;
    padding-left: 24px; /* 与标题对齐，24px = 图标宽度(16px) + 右边距(8px) */
  }

  .error-content {
    display: flex;
    flex-direction: column;
  }

  .error-text {
    font-family: "Open Sans regular";
    font-weight: 400;
    font-size: 14px;
    color: #1D2129;
    text-align: left;
  }

  .error-close {
    cursor: pointer;

    .el-icon-close {
      font-size: 12px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      color: #999;
    }
  }
}
</style>
